import type { MenuButtonEvent } from "@ebay/ebayui-core/dist/components/ebay-menu-button/component";
import type { Locality } from "@ebay/locale-ebay";
import type { MapItemCard } from "../../@types/mapviewxs";
import type { MarkerSelectionState, WatchListEntries } from "../map/types";
import { loadHelp } from "./helpers/loadHelp";

export type UnHoverItemEvent = { el: { parentElement: { querySelectorAll: (arg0: string) => any } } };

export interface Input {
  model: MapItemCard;
  handleWatchListItemToggle?: (listingid: string) => void;
  watchListItems?: WatchListEntries;
  index: number;
  isVisible?: boolean;
  selectionState: MarkerSelectionState;
  "on-item-hover"?: (markerIndex: number, listingId: string) => void;
  "on-unhover-item"?: (event: UnHoverItemEvent) => void;
}

export default class extends Marko.Component<Input> {
  onItemHover(markerIndex: number, listingId: string) {
    this.emit("item-hover", markerIndex, listingId);
  }

  onUnhoverItem() {
    this.emit("unhover-item");
  }

  onMenuSelect(locality?: Locality, event?: MenuButtonEvent) {
    if (event?.checked?.includes(0)) {
      loadHelp(this.input.model.card, locality);
    }
  }
}
